// extracted by mini-css-extract-plugin
module.exports = {"inactive":"VIP_QtyCellValueText__inactive","input-disabled":"VIP_QtyCellValueText__input-disabled","inputDisabled":"VIP_QtyCellValueText__input-disabled"};